import { useTranslation } from 'react-i18next';

// Organizing group, alphabetical by surname.
// Names and affiliations are intentionally kept in their original form (not
// translated) — institutional names follow the convention of staying in the
// home language regardless of the UI locale.
const ORGANIZING_GROUP = [
  { name: 'Arthos, John',          affiliation: 'Emeritus Professor of English, Indiana University' },
  { name: 'Bey, Facundo',           affiliation: 'Assistant Researcher at Instituto de Filosofía «Ezequiel de Olaso» (INEO-CIF/CONICET), Buenos Aires, Argentina' },
  { name: 'Johnson, Michael',       affiliation: 'Assistant Professor of Religion, Concordia College (Moorhead, Minnesota)' },
  { name: 'Nascimento, Fernando',   affiliation: 'Associate Professor of Digital and Computational Studies, Bowdoin College (Brunswick, Maine)' },
  { name: 'Nielsen, Cynthia R.',    affiliation: 'Professor of Philosophy, University of Dallas' },
  { name: 'Taylor, George H.',      affiliation: 'Emeritus Professor of Law, University of Pittsburgh' },
  { name: 'Weber, Barbara',         affiliation: 'Professor and Chair of the Interdisciplinary Studies Graduate Program, University of British Columbia' },
];

export default function About() {
  const { t } = useTranslation();

  return (
    <article className="mx-auto max-w-3xl px-6 pb-20 pt-28">
      <header className="mb-10">
        <div className="section-label">{t('about.label')}</div>
        <h1 className="font-serif text-4xl font-semibold text-cream">
          {t('about.heading')}
        </h1>
      </header>

      <div className="space-y-6 text-base leading-relaxed text-ink-primary">
        <p>{t('about.intro1')}</p>
        <p>{t('about.intro2')}</p>
        <p>{t('about.intro3')}</p>
        <p>{t('about.intro4')}</p>
      </div>

      <section className="mt-10 rounded-lg border border-gold/20 bg-navy-mid/30 p-6">
        <h2 className="mb-2 font-serif text-xl font-semibold text-gold-light">
          {t('about.contactHeading')}
        </h2>
        <p className="text-sm text-ink-secondary">
          {t('about.contactBody')}{' '}
          <a
            href="mailto:contact@hermeneuticscommons.org"
            className="text-gold-light hover:underline"
          >
            contact@hermeneuticscommons.org
          </a>
        </p>
      </section>

      <section className="mt-12">
        <h2 className="mb-6 font-serif text-2xl font-semibold text-cream">
          {t('about.membersHeading')}
        </h2>
        <ul className="grid gap-4 sm:grid-cols-2">
          {ORGANIZING_GROUP.map((m) => (
            <li
              key={m.name}
              className="rounded-md border border-white/10 bg-navy-base/40 p-4"
            >
              <div className="font-serif text-base font-semibold text-cream">{m.name}</div>
              <div className="mt-1 text-sm text-ink-secondary">{m.affiliation}</div>
            </li>
          ))}
        </ul>
      </section>
    </article>
  );
}
